// extracted by mini-css-extract-plugin
module.exports = {"content":"BlankLayout_content__3CwWg","footer":"BlankLayout_footer__3Xym6","layout":"BlankLayout_layout__3_A72"};